import React from 'react';
import { RingLoader } from 'react-spinners';
/*
    props.isWhole : 사이드바를 포함한 전체 영역에 대한 로딩바 노출을 위한 css 분기 변수명
*/
function Loading(props: any) {
    console.log('props', props);

    return (
        <>
            <div className={`${props.isWhole ? 'loading-container-in-whole' : 'loading-container'}`}>
                <RingLoader
                    color={'#2c3238'}
                    loading={true}
                    size={70}
                    // speedMultiplier={0.4}
                />
            </div>
        </>
    );
}

export default Loading;
